import resizeImageUrl from './utils/resize-image-url';

export default {
  menuOpen: null,
  activeMenu: null,
  activeMegaNavIndex: null,
  preferredStoreId: null,
  stores: [],
  searchDropdownOpen: false,
  cart: {
    totalItemCount: 0,
  },
  currency: {
    symbol: localization?.currency?.symbol || '',
  },
  wishlistProducts: [],
  wishlistLoading: true,
  customer: null,
  formErrors: {},

  signupTracking: {
    init() {
      const signupForms = [
        document.querySelector('#signup-form-desktop'), // desktop form
        document.querySelector('#signup-form'), // popup form
      ];

      signupForms.forEach((form) => {
        if (form) {
          form.addEventListener('submit', (e) => {
            const newsletterCheckbox =
              document.getElementById('RegisterForm-accepts-marketing') ||
              document.getElementById('PopupRegisterForm-accepts-marketing');

            const newsletterOptIn = newsletterCheckbox
              ? newsletterCheckbox.checked.toString()
              : 'false';

            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
              event: 'form_submit',
              form_id: 'create_customer',
              form_name: 'account_signup',
              form_destination: window.location.href,
              form_length: 10,
              newsletter_opt_in: newsletterOptIn,
              event_callback: 'Function',
            });
          });
        }
      });
    },
  },

  async init() {
    const storeUpdating = window.localStorage.getItem('storeUpdating');
    const isStoreUpdating = storeUpdating ? JSON.parse(storeUpdating) : false;
    const localStorageStoreId = window.localStorage.getItem('storeId');
    this.preferredStoreId = Number(localStorageStoreId);
    this.stores = window.store_locations;

    this.signupTracking.init();

    if (isStoreUpdating) {
      if (window.customer?.preferredStoreId === Number(localStorageStoreId)) {
        window.localStorage.setItem(
          'storeId',
          Number(window.customer?.preferredStoreId),
        );
        window.localStorage.setItem('storeUpdating', false);
      }
    } else {
      if (window.customer?.preferredStoreId) {
        this.preferredStoreId = Number(window.customer.preferredStoreId);
        window.localStorage.setItem(
          'storeId',
          Number(window.customer?.preferredStoreId),
        );
      }
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // Any publisher that carries cart data (cart-items, cart-sync, wishlists)
      // is the source of truth for the header count. A count of 0 is valid.
      const itemCount = event?.cartData?.item_count;

      if (typeof itemCount === 'number') {
        this.cart.totalItemCount = itemCount;
        return;
      }

      fetch('/cart.json')
        .then((response) => response.json())
        .then((data) => {
          this.cart.totalItemCount = data.item_count;
        })
        .catch((e) => {
          console.error(e);
        });
    });

    document.addEventListener('alpine:initialized', () => {
      setTimeout(() => {
        if (!window.SwymCallbacks) {
          window.SwymCallbacks = [];
        }
        window.SwymCallbacks?.push((swat) => this.fetchWishlists(swat));
      }, 0);
    });

    this.customer = window.customerData || null;
  },

  get preferredStore() {
    return this.stores.find(
      (store) => store.location_id === this.preferredStoreId,
    );
  },

  isUserLoggedIn() {
    return this.customer !== null;
  },

  fetchWishlists(swat) {
    swat.fetch((products) => {
      (async () => {
        const shopifyProducts = await this.fetchShopifyProducts(products);
        this.wishlistLoading = false;
        Alpine.store('main').wishlistProducts = shopifyProducts;
      })();
    });
  },

  submitForm(event) {
    event.preventDefault();
    const form = event.target;
    const fields = form.querySelectorAll('input');
    let hasErrors = false;

    // Clear all previous errors
    form.querySelectorAll('.error-message').forEach((el) => el.remove());
    form
      .querySelectorAll('.border-red-500')
      .forEach((el) => el.classList.remove('border-red-500'));

    // Re-validate all fields
    fields.forEach((field) => {
      if (this.validateField(field)) {
        hasErrors = true;
      }
    });

    if (!hasErrors) {
      // clear the form
      form.reset();
    }
  },

  validateField(field) {
    const value = field.value.trim();
    const name = field.name;
    let error = '';

    if (!value) {
      error = 'This field is required';
    } else if (name === 'customer[email]' && !this.isValidEmail(value)) {
      error = 'Please enter a valid email address';
    } else if (name === 'customer[password]' && !this.isValidPassword(value)) {
      error =
        'Password must be at least 8 characters long and include uppercase, lowercase, number, and special character';
    }

    this.displayFieldError(field, error);
    return error;
  },

  isValidEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  },

  isValidPassword(password) {
    // At least 8 characters long
    // Contains at least one uppercase letter, one lowercase letter, one number, and one special character
    const re =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;
    return re.test(password);
  },

  displayFieldError(field, error) {
    const errorElement = field.nextElementSibling;
    if (error) {
      field.classList.add('border-red-500');
      if (errorElement && errorElement.classList.contains('error-message')) {
        errorElement.textContent = error;
      } else {
        const newErrorElement = document.createElement('p');
        newErrorElement.textContent = error;
        newErrorElement.classList.add(
          'error-message',
          'text-red-500',
          'text-sm',
          'mt-1',
        );
        field.parentNode.insertBefore(newErrorElement, field.nextSibling);
      }
    } else {
      field.classList.remove('border-red-500');
      if (errorElement && errorElement.classList.contains('error-message')) {
        errorElement.remove();
      }
    }
  },

  displayServerErrors(form, errors) {
    Object.keys(errors).forEach((key) => {
      const field = form.querySelector(`[name="customer[${key}]"]`);
      if (field) {
        this.displayFieldError(field, errors[key][0]);
      }
    });
  },

  showWishlistLoginPopup() {
    const popup = document.getElementById('wishlist-login-popup');
    popup.classList.remove('hidden');
  },
  hideWishlistLoginPopup() {
    const popup = document.getElementById('wishlist-login-popup');
    popup.classList.add('hidden');
  },

  showWishlistSelectVariantModal(productId) {
    const isInWishlist = this.itemIsInWishlist(productId);

    if (isInWishlist) {
      const productData = this.wishlistProducts.find(
        (product) => product.id === productId,
      );

      if (productData) {
        this.removeItemFromWishlist({
          productId: productData.swymData.empi,
          variantId: productData.swymData.epi,
        });
      }
    } else {
      const modal = document.getElementById(
        `wishlist-select-variant-modal-id-${productId}`,
      );
      modal.classList.remove('hidden');
    }
  },
  hideWishlistSelectVariantModal(productId) {
    const modal = document.getElementById(
      `wishlist-select-variant-modal-id-${productId}`,
    );
    modal.classList.add('hidden');
  },

  fetchWishlists(swat) {
    swat.fetch((products) => {
      (async () => {
        const shopifyProducts = await this.fetchShopifyProducts(products);
        this.wishlistLoading = false;
        Alpine.store('main').wishlistProducts = shopifyProducts;
      })();
    });
  },

  async fetchShopifyProducts(swymProducts) {
    try {
      const shopifyProducts = await Promise.all(
        swymProducts
          .map(async (swymProduct) => {
            try {
              const productHandle = swymProduct.du.substring(
                swymProduct.du.lastIndexOf('/') + 1,
              );
              const productResponse = await fetch(
                `/products/${productHandle}?variant=${swymProduct.epi}&section_id=wishlist-card`,
                {
                  headers: {
                    'Content-Type': 'text/html',
                  },
                },
              ).then((res) => res.text());
              const cardHtml = new DOMParser()
                .parseFromString(productResponse, 'text/html')
                .querySelector('.shopify-section');
              const productId =
                cardHtml.querySelector('[data-product-id]')?.dataset?.productId;
              if (!productId) {
                return null;
              }
              return swymProduct
                ? {
                    id: swymProduct.empi,
                    html: cardHtml,
                    swymData: swymProduct,
                  }
                : null;
            } catch (e) {
              console.log('Error fetching shopify product', e);
              return null;
            }
          })
          .filter((test) => !!test),
      );
      return shopifyProducts.filter((product) => product !== null);
    } catch (e) {
      console.error('Error fetching wishlist products.', e);
      return [];
    }
  },

  addItemToWishlist(product) {
    return new Promise((resolve, reject) => {
      const swymData = {
        empi: product.productId,
        epi: product.variantId,
        du: product.url,
      };

      window._swat.addToWishList(swymData, () => {
        this.fetchWishlists(window._swat);
        resolve();
      });
    });
  },

  removeItemFromWishlist(productData) {
    const swymData = {
      empi: productData.productId,
      epi: productData.variantId,
    };
    window._swat.removeFromWishList(swymData, () => {
      this.fetchWishlists(_swat);
    });
  },

  pdpAddItemToWishlist(product) {
    const variantIdEle = document.querySelectorAll('.product-variant-id');

    if (variantIdEle.length > 0) {
      const variantId = variantIdEle[0].value;

      const swymData = {
        empi: product.productId,
        epi: Number(variantId),
        du: product.url,
      };

      window._swat.addToWishList(swymData, () => {
        this.fetchWishlists(_swat);
      });
    }
  },

  pdpRemoveItemFromWishlist(productData) {
    const wishlistProduct = this.wishlistProducts.find(
      (p) => p.id === productData.productId,
    );

    if (!wishlistProduct) {
      console.warn('Product not found in wishlist');
      return;
    }

    const variantId = wishlistProduct.swymData.epi;

    const swymData = {
      empi: productData.productId,
      epi: variantId,
    };

    window._swat.removeFromWishList(swymData, () => {
      this.fetchWishlists(window._swat);
    });
  },

  removeAllItemsFromWishlist() {
    const swymProductsToRemove = [...this.wishlistProducts];
    swymProductsToRemove.forEach((productToRemove) => {
      window._swat.removeFromWishList(productToRemove.swymData, () => {
        const newWishlistProducts = [
          ...this.wishlistProducts.filter(
            (product) => product.id !== productToRemove.id,
          ),
        ];
        Alpine.store('main').wishlistProducts = newWishlistProducts;
      });
    });
  },

  itemIsInWishlist(productId) {
    const findProduct = this.wishlistProducts.find(
      (product) => product.id === productId,
    );
    return !!findProduct;
  },

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  },

  toggleCart() {
    const cartDrawer = document.querySelector('cart-drawer');
    const isOpen = cartDrawer.classList.contains('active');
    if (isOpen) {
      cartDrawer.close();
    } else {
      cartDrawer.open();
    }
  },

  setPreferredStore(storeId, email) {
    this.preferredStoreId = storeId;
    window.localStorage.setItem('storeId', Number(storeId));
    document.dispatchEvent(
      new CustomEvent('CUSTOMER::STORE_PREFERRED_UPDATED', {
        detail: { storeId },
      }),
    );

    if (email) {
      window.localStorage.setItem('storeUpdating', true);
      this.setStore(email, storeId);
    }
  },

  async setStore(email, storeId) {
    const options = {
      method: 'POST',
      headers: {
        accept: 'text/html',
        'content-type': 'application/x-www-form-urlencoded',
      },
      body: new URLSearchParams({
        data: `{"token": "WZy9ma", "properties": {"$email": "${email}" , "preferred_store": "${storeId}"}}`,
      }),
    };

    fetch('https://a.klaviyo.com/api/identify', options)
      .then((response) => response.json())
      .then((response) => console.log(response))
      .catch((err) => console.error(err));
  },

  getResizedImageUrl(imageUrl, size) {
    return resizeImageUrl(imageUrl, size);
  },
};
